import { StandaloneIcon } from 'base/components/standalone/Icon';
import { iconsDictionary } from './Icon.dictionary';

export const HantStandaloneIcon: typeof StandaloneIcon = (props) => {
  return <StandaloneIcon dictionary={iconsDictionary} {...props} />;
};
